/*
 * EL BUSCADOR — el mismo modal del sitio, con el catalogo de verdad.
 *
 * La lupa de la cabecera lleva `search-modal-trigger`, el gancho del tema base,
 * pero su modal vive en una seccion que nuestro layout no renderiza: el enlace
 * acababa navegando a /search. Aqui se intercepta y se abre este.
 *
 * Los resultados salen de /search/suggest.json, la API predictiva de Shopify.
 * No devuelve variantes, asi que el boton de agregar usa `quick-add-trigger`
 * —el selector de opciones del tema base—, que si sabe resolverlas.
 */
(function () {
  "use strict";

  var caja = document.querySelector("[data-eu-buscador]");
  if (!caja) return;

  var campo = caja.querySelector("[data-eu-buscador-campo]");
  var borrar = caja.querySelector("[data-eu-buscador-borrar]");
  var salida = caja.querySelector("[data-eu-buscador-resultados]");
  var sugerencias = caja.querySelector("[data-eu-buscador-sugerencias]");
  var chips = caja.querySelector("[data-eu-buscador-chips]");
  var formulario = caja.querySelector("[data-eu-buscador-form]");
  var abridor = null;
  var espera = null;
  var peticion = 0;

  var ARTISTAS = { CAKE: "Cake", OSO: "Oso de Agua", MONKS: "The Monks", "ESPACIO UNNO": "Espacio Unno" };

  function escapar(t) {
    return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* El catalogo tiene los titulos en mayusculas; en la tarjeta van en caja de titulo. */
  function cajaTitulo(t) {
    return String(t || "").toLowerCase();
  }

  function artistaDe(etiquetas) {
    for (var i = 0; i < (etiquetas || []).length; i++) {
      var e = String(etiquetas[i]).toUpperCase().trim();
      if (ARTISTAS[e]) return ARTISTAS[e];
    }
    return "";
  }

  function soles(precio) {
    return String(precio || "").split(".")[0];
  }

  /* ---------------------------------------------------------- abrir/cerrar */

  function enfocables() {
    return [].slice
      .call(caja.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (e) {
        return !e.hasAttribute("hidden") && (e.offsetWidth > 0 || e.offsetHeight > 0);
      });
  }

  function abrir(desde) {
    abridor = desde || null;
    caja.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      if (campo) campo.focus();
    }, 60);
  }

  function cerrar() {
    caja.classList.remove("is-open");
    document.body.style.overflow = "";
    if (abridor && abridor.focus) abridor.focus();
    abridor = null;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var lupa = t.closest(".search-modal-trigger");
    if (lupa) {
      e.preventDefault();
      abrir(lupa);
      return;
    }
    if (t.closest("[data-eu-buscador-cerrar]")) {
      e.preventDefault();
      cerrar();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!caja.classList.contains("is-open")) return;
    if (e.key === "Escape") {
      e.preventDefault();
      cerrar();
      return;
    }
    if (e.key !== "Tab") return;
    var lista = enfocables();
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  });

  /* ------------------------------------------------------------ sugerencias */

  var lista = (caja.getAttribute("data-sugerencias") || "").split(",");
  for (var i = 0; i < lista.length; i++) {
    var texto = lista[i].trim();
    if (!texto) continue;
    var b = document.createElement("button");
    b.type = "button";
    b.className =
      "ficha min-h-11 rounded-full border-2 border-verde/35 px-4 font-semibold transition-colors hover:border-verde hover:bg-lima";
    b.textContent = texto;
    b.addEventListener("click", function () {
      campo.value = this.textContent;
      campo.focus();
      consultar();
    });
    chips.appendChild(b);
  }

  /* --------------------------------------------------------------- resultados */

  function pinta(html, hayConsulta) {
    salida.innerHTML = html;
    salida.hidden = !hayConsulta;
    sugerencias.hidden = hayConsulta;
  }

  function tarjeta(p) {
    var artista = artistaDe(p.tags);
    var meta = [artista, p.type].filter(Boolean).join(" · ");
    /* featured_image es un objeto con .url; image es la URL suelta. Y se pide
       al ancho que se ve (56 px a 2x) en vez de la original de 1254. */
    var foto = (p.featured_image && p.featured_image.url) || p.image || "";
    if (foto) foto += (foto.indexOf("?") === -1 ? "?" : "&") + "width=112";
    return (
      '<li class="flex items-center gap-3 p-2.5">' +
      '<a href="' + escapar(p.url) + '" class="flex min-w-0 flex-1 items-center gap-3">' +
      '<span class="relative size-14 shrink-0 overflow-hidden rounded-xl border-2 border-verde/15 bg-crema">' +
      (foto ? '<img src="' + escapar(foto) + '" alt="" loading="lazy" class="absolute inset-0 h-full w-full object-contain p-1">' : "") +
      "</span>" +
      '<span class="min-w-0">' +
      '<span class="block truncate font-display text-[1.15rem] leading-tight font-bold capitalize">' + escapar(cajaTitulo(p.title)) + "</span>" +
      (meta ? '<span class="ficha block">' + escapar(meta) + "</span>" : "") +
      "</span></a>" +
      '<span class="etiqueta items-center leading-none px-2.5 py-1.5 shrink-0">' +
      '<span class="flex items-baseline gap-1.5"><span class="font-display font-bold tracking-tight text-[1.12rem]">' +
      '<span class="text-[0.62em] align-[0.18em] pr-[1px]">s./</span>' + escapar(soles(p.price)) + "</span></span></span>" +
      '<button type="button" class="quick-add-trigger grid size-11 shrink-0 place-items-center rounded-full! border-2 border-verde transition-colors hover:bg-verde hover:text-lima"' +
      ' data-product-handle="' + escapar(p.handle) + '" aria-label="Agregar ' + escapar(p.title) + ' al carrito">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" class="size-4"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path></svg>' +
      "</button></li>"
    );
  }

  function consultar() {
    var q = (campo.value || "").trim();
    if (!q) {
      pinta("", false);
      borrar.hidden = true;
      return;
    }
    borrar.hidden = false;
    var mio = ++peticion;
    var url =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") +
      "search/suggest.json?q=" +
      encodeURIComponent(q) +
      "&resources%5Btype%5D=product&resources%5Blimit%5D=8";

    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (mio !== peticion) return; // llego una respuesta vieja
        var ps = ((d.resources || {}).results || {}).products || [];
        if (!ps.length) {
          pinta(
            '<p class="ficha mb-2">Nada con «' + escapar(q) + '»</p>' +
              '<p class="parrafo">Prueba con el nombre de un artista, una categoría o una pieza.</p>',
            true,
          );
          return;
        }
        var cuerpo = "";
        for (var i = 0; i < ps.length; i++) cuerpo += tarjeta(ps[i]);
        pinta(
          '<p class="ficha mb-2">' + ps.length + (ps.length === 1 ? " resultado" : " resultados") + "</p>" +
            '<ul class="divide-y divide-verde/15 rounded-2xl border-2 border-verde/20 bg-white">' + cuerpo + "</ul>",
          true,
        );
        /* el quick add del tema base engancha los botones nuevos */
        if (typeof window.initCartAjaxHandlers === "function") window.initCartAjaxHandlers();
      })
      .catch(function () {
        if (mio !== peticion) return;
        pinta('<p class="parrafo">No se pudo buscar ahora mismo. Inténtalo otra vez.</p>', true);
      });
  }

  campo.addEventListener("input", function () {
    clearTimeout(espera);
    espera = setTimeout(consultar, 220);
  });

  borrar.addEventListener("click", function () {
    campo.value = "";
    campo.focus();
    consultar();
  });

  /* Enter lleva a la página de búsqueda completa, con todos los resultados. */
  formulario.addEventListener("submit", function (e) {
    if (!(campo.value || "").trim()) e.preventDefault();
  });
})();
